import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { PhotoLibrarySystemIcon } from '@nib/icons';
import Copy from './Copy';
import { Column, Columns } from '@nib/layout';
const ZeroFontSizeColumn = styled(Column)`
  font-size: 0;

  svg {
    position: relative;
    inset-block-start: 2.5px;
  }
`;
export const ImageCaption = _ref => {
  let {
    children,
    showIcon = false,
    ...otherProps
  } = _ref;
  if (!showIcon) {
    return /*#__PURE__*/_jsx(Copy, {
      size: "small",
      color: "muted",
      measure: false,
      ...otherProps,
      "data-mesh-component": "IMAGE-CAPTION",
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(Columns, {
    space: 2,
    ...otherProps,
    "data-mesh-component": "IMAGE-CAPTION",
    children: [/*#__PURE__*/_jsx(ZeroFontSizeColumn, {
      width: "content",
      children: /*#__PURE__*/_jsx(PhotoLibrarySystemIcon, {
        size: "xs",
        fill: "muted"
      })
    }), /*#__PURE__*/_jsx(Column, {
      children: /*#__PURE__*/_jsx(Copy, {
        size: "small",
        color: "muted",
        component: "div",
        measure: false,
        children: children
      })
    })]
  });
};
ImageCaption.displayName = 'ImageCaption';